import React, {useState} from 'react'
import toast from 'react-hot-toast';
import { db } from "./Firebase";
import {setDoc, collection, getDocs, query, doc, where } from "firebase/firestore";
import Map from "../assets/Icon-1.png";
import Calendar from "../assets/Icon-2.png";
import Smiley from "../assets/Icon-3.png";
import Notification from "../assets/Icon-4.png";
import Sparks from "../assets/Icon-5.png";
import { isValidEmail, toDateTime } from './Home';
import emailjs from "@emailjs/browser"
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import qrCode from "../assets/StoreQrCode.png";
import { delay, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const Section1 = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const colRef = collection(db, "signups");

  const signup = async () => {
    try {
      if (loading) return;
      if (!email.trim() || !name.trim() || !isValidEmail(email)) return;
      setLoading(true);
      const docSearch = await getDocs(
        query(colRef, where("email", "==", email))
      );
      if (docSearch.docs.length == 0) {
        await setDoc(doc(colRef), { email, name, entry_date: toDateTime() });
        //toast.success("Thank you for signing up!")
        emailjs
          .send(
            "service_h4br5is",
            "template_3bi0wub",
            { name, email },
            { publicKey: "grg76XmeXnwqwv5cy" }
          )
          .then(
            (response) => {
              window.location.replace("/thanks");
              console.log("SUCCESS!", response.status, response.text);
            },
            (error) => {
              console.log("FAILED...", error);
              setLoading(false);
              toast("Error sending email", {
                icon: "⚠️",
              });
            }
          );
      } else {
        //console.log("Already exists");
        toast("You have already subscribed", {
          icon: "⚠️",
        });
        setLoading(false);
      }
    } catch (err) {
      toast("An error has occured", {
        icon: "⚠️",
      });
      console.log(err);
      setLoading(false);
    }
  };
  const listVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, delay: 0.5 } },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.8,
        delay: 0.5,
        duration: 0.6,
      },
    },
  };
  const [ref1, inView1] = useInView({ triggerOnce: true });
  return (
    <motion.div
      ref={ref1}
      id="users"
      className="section1"
      initial="hidden"
      animate={inView1 ? "visible" : " "}
      variants={containerVariants}
    >
      {/* <div className='big-yellow-circle2' />
        <img alt='phone 1' src={Phone1} className='phone1' /> */}

      <div style={{ flex: 0.5 }} className="section1-seperator" />
      <div className="section1-minisection" style={{ flex: 0.5 }}>
        <motion.h1 variants={listVariants}>Features & Benefits</motion.h1>
        <motion.div className="section1-p" variants={listVariants}>
          <ul style={{ listStyleType: "none" }}>
            <motion.li variants={listVariants}>
              <div className="list-div">
                <img
                  alt=""
                  src={Map}
                  style={{ objectFit: "contain", width: 30, height: 30 }}
                />
                <p>Explore services and discover new service providers</p>
              </div>
            </motion.li>
            <motion.li variants={listVariants}>
              <div className="list-div">
                <img
                  alt=""
                  src={Calendar}
                  style={{ objectFit: "contain", width: 30, height: 30 }}
                />
                <p>See availability live from the app</p>
              </div>
            </motion.li>
            <motion.li variants={listVariants}>
              <div className="list-div" style={{ alignItems: "flex-start" }}>
                <img
                  alt=""
                  src={Smiley}
                  style={{ objectFit: "contain", width: 30, height: 30 }}
                />
                <p>
                  24/7 booking and at your convenience from the app without
                  calling or using third party messaging tools
                </p>
              </div>
            </motion.li>
            <motion.li variants={listVariants}>
              <div className="list-div">
                <img
                  alt=""
                  src={Notification}
                  style={{ objectFit: "contain", width: 30, height: 30 }}
                />
                <p>
                  Get reminded of your appointment to stay on top of your
                  schedule
                </p>
              </div>
            </motion.li>
            <motion.li variants={listVariants}>
              <div className="list-div">
                <img
                  alt=""
                  src={Sparks}
                  style={{ objectFit: "contain", width: 30, height: 30 }}
                />
                <p>Get unique benefits and deals</p>
              </div>
            </motion.li>
          </ul>
        </motion.div>
        {/* <p className='first-to-know'>BE THE FIRST TO KNOW WHEN WE LAUNCH!</p>
                <input value={name} onChange={(e) => setName(e.target.value)} type='text' placeholder='Name' className='home-input' />
                <input
                value={email} 
                onChange={(e) => setEmail(e.target.value)}
                type='email' 
                placeholder='Email' 
                className='home-input' />
                <div 
                style={{marginTop: 15, opacity: loading ? 0.5 : 1}}
                onClick={() => !email.trim() || !name.trim() || !isValidEmail(email) ? toast("Please enter your name & email", {icon: '⚠️'}) : signup()}
                className='subscribe-btn' 
                >
              {!loading ?
                <p>SUBSCRIBE</p>
              :
              <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    fontSize: 24,
                    color: 'white'
                  }}
                  spin
                />
              }
            />
              }
                </div> */}
        <motion.div className="qrCodeContainerS1" variants={listVariants}>
          <p className="scan-to-download"> SCAN & DOWNLOAD</p>
          <img
            src={qrCode}
            width={160}
            height={160}
            style={{ marginTop: "20px" }}
            alt=""
          />
          {/* <p style={{ marginTop: "20px", color: "black", fontSize: "24px" }}>
            Register your business with us{" "}
            <a href="#business" style={{ color: "#008a80" }}>
              here
            </a>
          </p> */}
        </motion.div>
        <div style={{ marginTop: "30px" }}>
          <motion.div
            className="downloadbtn"
            variants={listVariants}
            onClick={(event) => (window.location.href = "/store")}
          >
            <p> DOWNLOAD NOW</p>
          </motion.div>

          <motion.div
            className="downloadButtonsContainer"
            variants={listVariants}
          >
            <div className="StoreButtons">
              <div id="IOS">
                <a
                  target="_blank"
                  className="market-btn apple-btn"
                  role="button"
                >
                  <span className="market-button-subtitle">
                    Download on the
                  </span>
                  <span className="market-button-title">App Store</span>
                </a>
              </div>
              <div id="Droid">
                <a
                  target="_blank"
                  className="market-btn google-btn"
                  role="button"
                >
                  <span className="market-button-subtitle">Get it on</span>
                  <span className="market-button-title">Google Play</span>
                </a>
              </div>
            </div>
          </motion.div>
          <p className="RegisterBusiness">
            Register your business with us{" "}
            <a href="#business" style={{ color: "#008a80" }}>
              here
            </a>
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default Section1;
